import { Product } from "@type/products";
import { Category } from "@type/categories";
import styles from "./ProductItem.module.scss";
import { useAppContext } from "@context/appContext";
import { Badge } from "@eventsquare/uikit";
import { RiDrinks2Line } from "@remixicon/react";
import { useState, useRef } from "react";

interface ItemProps {
  product: Product;
  category: Category;
  onHold: (product: Product) => void;
}

const ProductItem = ({ product, category, onHold }: ItemProps) => {
  const { add, cart = [] } = useAppContext();
  const [isActive, setIsActive] = useState(false);
  const holdTimer = useRef<NodeJS.Timeout | null>(null);

  const cartAmount =
    cart.find((item) => item.uid === product.uid)?.quantity || 0;

  const handleTouchStart = () => {
    setIsActive(true);
    holdTimer.current = setTimeout(() => {
      onHold(product);
      setIsActive(false);
    }, 500);
  };

  const handleTouchEnd = () => {
    if (holdTimer.current) {
      clearTimeout(holdTimer.current);
      holdTimer.current = null;
    }
    setIsActive(false);
  };

  const handleTouchCancel = () => {
    if (holdTimer.current) {
      clearTimeout(holdTimer.current);
      holdTimer.current = null;
    }
    setIsActive(false);
  };

  const handleClick = () => {
    add(product.uid);
    setIsActive(false);
  };

  const renderImage = () => {
    if (!product.image) {
      return (
        <div className={styles.productImageContainer}>
          <div className={styles.productIconContainer}>
            <RiDrinks2Line />
          </div>
        </div>
      );
    }
    return (
      <div className={styles.productImageContainer}>
        <img
          src={product.image}
          alt={product.name}
          className={styles.productImage}
        />
      </div>
    );
  };

  return (
    <button
      className={`${styles.productItem} ${isActive ? styles.active : ""}`}
      style={{ backgroundColor: category.color }}
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchCancel}
      type="button"
    >
      {renderImage()}
      {cartAmount > 0 && (
        <div className={styles.productBadgeContainer}>
          <Badge content={cartAmount} />
        </div>
      )}
      <h3 className={styles.productName}>
        <span>{product.name}</span>
      </h3>
    </button>
  );
};

export default ProductItem;
